import { createContext, useContext } from '@wordpress/element';
const RovingTabIndexContext = createContext(undefined);
RovingTabIndexContext.displayName = 'RovingTabIndexContext';
export const useRovingTabIndexContext = () => useContext(RovingTabIndexContext);
export const RovingTabIndexProvider = RovingTabIndexContext.Provider;